import apiClient from './apiClient';
import createCrudApi from './createCrudApi';

const feeClient = apiClient('fee');

const feeLevelsApi = createCrudApi(feeClient, 'levels'); // для getAll
const feeDiscountsApi = createCrudApi(feeClient, 'discounts');

const feeApi = {
    feeLevelsApi,
    feeDiscountsApi,

    async calculateFee(promoId, participantsCount) {
        const res = await feeClient.get(`calculate/${promoId}/${participantsCount}`);
        return res.data;
    },
    async calculateFeeGem(promoId, participantsCount) {
        const res = await feeClient.get(`calculate-gem/${promoId}/${participantsCount}`);
        return res.data;
    },
    /** Калькуляция fee для нового gem промо (без promoId, без скидок) */
    async calculateGemFeePreview(participantsCount) {
        const res = await feeClient.get(`calculate-gem/0/${participantsCount}`);
        return res.data;
    },
    async getDiscountStatus(promoId) {
        const res = await feeClient.get(`discount-status/${promoId}`);
        return res.data;
    },
};

export default feeApi;
